/**
 * One address, one place.
 *
 * This is where enquiries land: `deliverEnquiry` sends here unless
 * CONTACT_TO_EMAIL overrides it. It is a Cloudflare Email Routing address on
 * the site's own domain, forwarded to the business mailbox — so the address a
 * visitor sees is the domain they are buying from, and where it ultimately
 * lands can change without touching this file.
 *
 * There used to be `CONTACT_HREF` and `PRICING_HREF` here, prefilled `mailto:`
 * links used by every call to action on the site. They were written before
 * /contact existed. A form that validates, records what to look at, and can
 * answer a visitor beats handing them off to whatever mail client the browser
 * decides to open, so the buttons point at the page and this is now the
 * fallback for people who would rather write their own email.
 */
export const CONTACT_EMAIL = "dpwatz@keglamservices.com";
